/**
 *    Copyright 2018 the original author or authors
 *
 *    Licensed under the Apache License, Version 2.0 (the "License");
 *    you may not use this file except in compliance with the License.
 *    You may obtain a copy of the License at
 *
 *        http://www.apache.org/licenses/LICENSE-2.0
 *
 *    Unless required by applicable law or agreed to in writing, software
 *    distributed under the License is distributed on an "AS IS" BASIS,
 *    WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *    See the License for the specific language governing permissions and
 *    limitations under the License.
 */
import * as tslib_1 from "tslib";
import { Component, Input } from '@angular/core';
import { ObservableMedia } from '@angular/flex-layout';
import { MatSnackBar } from '@angular/material';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { mergeMap } from 'rxjs/operators/mergeMap';
import { ApiItemService } from './api-item.service';
import { ApiTableService } from '../api-table/api-table.service';
var ApiItemComponent = /** @class */ (function () {
    function ApiItemComponent(media, apiTableService, snackBar, service) {
        this.media = media;
        this.apiTableService = apiTableService;
        this.snackBar = snackBar;
        this.service = service;
        /**
         * Form used to create an item(Entity)
         */
        this.itemFormGroup = new FormGroup({});
    } // constructor()
    ApiItemComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.apiTableService
            .getModel(this.model)
            .pipe(mergeMap(function (meta) { return _this.handleMetaModel(meta); }))
            .subscribe(function (res) {
            _this.handleResponse(res);
        }, function (err) {
            _this.snackBar.open(err.message, '', {
                duration: 3000
            });
        });
    }; // ngOnInit()
    ApiItemComponent.prototype.ngOnDestroy = function () {
        if (this.all$)
            this.all$.unsubscribe();
    }; // ngOnDestroy()
    ApiItemComponent.prototype.save = function () {
        var _this = this;
        //  console.log(this.itemFormGroup.value)
        if (this.itemFormGroup.valid) {
            this.all$ = this.service.save(this.itemFormGroup.value, this.modelMeta).subscribe(function (res) {
                _this.handleResponse(res);
                _this.id = _this.service.rest.getId(res._links.self.href);
                _this.snackBar.open('Saved', '', { duration: 1000 });
            }, function (error) { return _this.handleErrors(error); });
        }
    }; // save()
    ApiItemComponent.prototype.handleResponse = function (response) {
        var _this = this;
        this.item = response;
        this.modelMeta.properties.forEach(function (prop) {
            if (response._links && response._links[prop.name]) {
                var val = response._links[prop.name];
                _this.itemFormGroup.controls[prop.name].patchValue(val.href);
            }
            else
                _this.itemFormGroup.controls[prop.name].patchValue(response[prop.name]);
        });
        // Manualy inject the _links.
        if (response._links) {
            this.itemFormGroup.controls['_links'].patchValue(response._links);
        }
    }; // handleResponse()
    ApiItemComponent.prototype.handleMetaModel = function (meta) {
        var _this = this;
        this.modelMeta = meta;
        this.properties = meta.properties.filter(function (p) { return p.type !== 'file'; });
        this.modelMeta.properties.forEach(function (prop) {
            var testCtrl = new FormControl();
            if (prop.required)
                testCtrl.setValidators(Validators.required);
            _this.itemFormGroup.addControl(prop.name, testCtrl);
        });
        // _links ctrl
        var _links = new FormControl();
        this.itemFormGroup.addControl('_links', _links);
        return this.service.getItem(this.modelMeta, this.id);
    }; // handleMetaModel()
    ApiItemComponent.prototype.delete = function () {
        this.service.delete(this.item);
    }; // delete
    ApiItemComponent.prototype.handleErrors = function (httpErrorResponse) {
        var message = httpErrorResponse.message;
        if (httpErrorResponse.error) {
            message = httpErrorResponse.error.message;
        }
        if (httpErrorResponse.status == 409) {
            message = 'Duplicate entry';
        }
        this.snackBar.open(message, '', {
            duration: 3000
        });
    }; // handleErrors()
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", Object)
    ], ApiItemComponent.prototype, "id", void 0);
    tslib_1.__decorate([
        Input(),
        tslib_1.__metadata("design:type", String)
    ], ApiItemComponent.prototype, "model", void 0);
    ApiItemComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-api-item',
            template: "<!-- Copyright 2018 the original author or authors Licensed under the Apache License, Version 2.0 (the \"License\"); you may not use this file except in compliance with the License. You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0 Unless required by applicable law or agreed to in writing, software distributed under the License is distributed on an \"AS IS\" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied. See the License for the specific language governing permissions and limitations under the License. --> <div> <div fxFlex=\"10%\" fxFlex.xs=\"1vw\"></div> <div fxFlex style=\"margin-top:1vh\"> <mat-card [ngClass]=\"{'mat-elevation-z0' : media.isActive('xs')}\"> <!--header --> <div fxLayout=\"row\" fxLayoutAlign=\"center center\"> <h3 class=\"shaded-title\"> <span *ngIf=\"id ==0 && !item?._links?.self?.href\" class=\"shaded-title\">New </span>{{modelMeta?.name | camelCase}} </h3> <span fxFlex></span> <button *ngIf=\"id!=0\" mat-icon-button matTooltip=\"History\"> <mat-icon class=\"icon-button\"> <svg id=\"history\" viewBox=\"0 0 24 24\"> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z\" /> </svg> </mat-icon> </button> <button *ngIf=\"id!=0\" mat-icon-button (click)=\"delete()\" matTooltip=\"Delete\"> <mat-icon class=\"icon-button\"> <svg id=\"delete\" viewBox=\"0 0 24 24\"> <path d=\"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\" /> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> </svg> </mat-icon> </button> </div> <form [formGroup]=\"itemFormGroup\" fxLayout.xs=\"column\" fxLayout.lg=\"row\" fxLayoutGap.lg=\"1vw\" fxLayoutWrap> <div fxFlex=\"100\" fxFlex.lg=\"48\" *ngFor=\"let prop of properties\"> <!-- Number --> <mat-form-field *ngIf=\"prop.type == 'number'\"> <input style=\"width: 100%;\" matInput type=\"number\" [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!-- String --> <mat-form-field fxFlex *ngIf=\"prop.type == 'string'\"> <input matInput [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!-- Color --> <mat-form-field fxFlex *ngIf=\"prop.type == 'color'\"> <input type=\"color\" matInput [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> <!-- Object --> <div fxFlex *ngIf=\"prop.relationShipType && (prop.relationShipType === 'SINGLE'|| prop.relationShipType === 'MULTIPLE')  && prop.type !== 'file'\"> <ext-api-select [(item)]=\"item\" [property]=\"prop\" [formControlName]=\"prop.name\"></ext-api-select> </div> <!--Enum --> <mat-form-field fxFlex *ngIf=\"prop.relationShipType && prop.relationShipType === 'ENUM'\"> <mat-select [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-option *ngFor=\"let enum of prop.enums\" [value]=\"enum\"> {{ enum }} </mat-option> </mat-select> </mat-form-field> <!-- Date --> <mat-form-field fxFlex *ngIf=\"prop.type == 'date'\"> <input matInput [matDatepicker]=\"picker\" [placeholder]=\"prop.name | camelCase\" [formControlName]=\"prop.name\"> <mat-datepicker-toggle matSuffix [for]=\"picker\"></mat-datepicker-toggle> <mat-datepicker [touchUi]=\"media.isActive('xs')\" #picker></mat-datepicker> <mat-error *ngIf=\"itemFormGroup.controls[prop.name].hasError('required')\"> {{prop.name | camelCase}} <strong>required</strong> </mat-error> </mat-form-field> </div> <button type=\"submit\" mat-fab class=\"bottom-right\" (click)=\"save()\" matTooltip=\"Save\"> <mat-icon> <svg id=\"save\" viewBox=\"0 0 24 24\" class=\"primary-text\"> <path d=\"M0 0h24v24H0z\" fill=\"none\" /> <path d=\"M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z\" /> </svg> </mat-icon> </button> </form> <!-- File Input dialog --> <div *ngIf=\"item?._links\"> <div *ngFor=\"let prop of modelMeta?.properties\"> <div *ngIf=\"prop.type == 'file'\"> <ext-file-upload [property]=\"prop\" [item]=\"item\"></ext-file-upload> </div> </div> </div> </mat-card> </div> <div fxFlex=\"10%\" fxFlex.xs=\"0\"></div> </div> <div style=\"height: 10vh\"></div>",
            styles: [".bottom-right { position: fixed; bottom: 24px; right: 24px; z-index: 100; } /*# sourceMappingURL=api-item.component.css.map */ "]
        }),
        tslib_1.__metadata("design:paramtypes", [ObservableMedia,
            ApiTableService,
            MatSnackBar,
            ApiItemService])
    ], ApiItemComponent);
    return ApiItemComponent;
}()); // class
export { ApiItemComponent };
//# sourceMappingURL=api-item.component.js.map